var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { stringBuilder } from '../util';
const TuxCheckboxWrapper = forwardRef(function TuxCheckbox(props, ref) {
    const { id, invalid, name, label, checked, disabled = false, className, indeterminate = false, toggle = false, required = false } = props, rest = __rest(props, ["id", "invalid", "name", "label", "checked", "disabled", "className", "indeterminate", "toggle", "required"]);
    const classes = stringBuilder('binary_checkbox_container', className);
    const labelClasses = stringBuilder({
        toggle_filter: toggle,
        checkbox: !toggle
    });
    return (_jsxs("div", Object.assign({ className: classes }, { children: [_jsx("input", Object.assign({}, rest, { "aria-checked": indeterminate ? 'mixed' : checked, "aria-invalid": invalid, "aria-required": required, checked: checked, className: "tuxedo_checkbox", disabled: disabled, id: id, name: name || id, onChange: (e) => props.onChange(e.target.checked), ref: ref, type: "checkbox" }), void 0), _jsx("label", Object.assign({ className: labelClasses, htmlFor: id }, { children: label }), void 0)] }), void 0));
});
export default TuxCheckboxWrapper;
